import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { getSampleThoughts, type SampleThought } from "~/api/askDynamo"

interface EverWonderedAskDynamoSectionProps {
  dogName: string
}

export function EverWonderedAskDynamoSection({ dogName }: EverWonderedAskDynamoSectionProps) {
  const [questions, setQuestions] = useState<SampleThought[]>([])

  useEffect(() => {
    getSampleThoughts(3)
      .then(setQuestions)
      .catch(() => setQuestions([]))
  }, [])

  if (questions.length === 0) return null

  return (
    <section
      className="mt-8 rounded-2xl border border-[var(--color-ask-dynamo)]/15 bg-gradient-to-br from-[var(--color-ask-dynamo-surface)]/80 to-white/70 p-5"
      aria-labelledby="ever-wondered-heading"
    >
      <h2
        id="ever-wondered-heading"
        className="text-lg font-semibold text-[var(--color-text-primary)]"
      >
        Ever wondered...
      </h2>
      <p className="mt-2 text-sm text-[var(--color-text-secondary)]">
        People often ask{" "}
        <span className="font-semibold text-[var(--color-ask-dynamo)]">Ask Dynamo</span> questions
        like these about their dogs.
      </p>
      <ul className="mt-4 flex flex-col gap-2">
        {questions.map((question) => (
          <li key={question.sequence_number}>
            <Link
              to={`/ask-dynamo?q=${encodeURIComponent(question.text)}`}
              className="block rounded-lg border border-white/80 bg-white/70 px-3 py-2.5 text-left text-sm text-[var(--color-text-primary)] transition hover:bg-white"
            >
              {question.text}
            </Link>
          </li>
        ))}
      </ul>
      <Link
        to="/ask-dynamo"
        className="mt-4 inline-flex text-sm font-medium text-[var(--color-ask-dynamo-muted)] underline"
      >
        Ask Dynamo about {dogName} →
      </Link>
    </section>
  )
}
